import STORE_CONST from '../consts'
import sshkeyApi from '../../api/sshkey'

const state = {
  sshKey: []
}

const mutations = {
  // get sshkey list
  [STORE_CONST.SSHKEY.GET] (state, sshKey) {
    state.sshKey = sshKey
  }
}

const actions = {
  // get sshkey list
  [STORE_CONST.SSHKEY.GET] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      sshkeyApi.getList(params).then(res => {
        commit(STORE_CONST.SSHKEY.GET, res.data.objects)
        resolve(res.data)
      })
    })
  },
  // add sshkey list
  [STORE_CONST.SSHKEY.ADD] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      sshkeyApi.addKey(params).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err.data)
      })
    })
  },
  // del sshkey list
  [STORE_CONST.SSHKEY.DEL] ({ commit }, id) {
    return new Promise((resolve, reject) => {
      sshkeyApi.delKey(id).then(res => {
        resolve(res.data)
      })
    })
  }
}

const getters = {
  sshKey: state => {
    return state.sshKey
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/sshkey.js